module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Dickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Dickson lives in South Yorkshire with her retired farm manager husband. On leaving school she entered the nursing profession, which she left to bring up a young family. Having moved out of the chaotic farmhouse, she has more time to indulge in her favourite pastimes. She enjoys being outdoors, travelling, reading and music. An incurable romantic, she writes for pleasure. It was a love of history that drove her to writing historical romantic fiction."), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7fez13/tc-custom/9781460320150.jpg?1704268788537",
      "alt": "This image is the cover for the book Master of Stonegrave Hall"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Master of Stonegrave Hall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Few defy Lord Rockford and come away unscathed "), _c('br'), _c('br'), _vm._v("Victoria Lewis has grown up in the long, dark shadows cast by Stonegrave Hall. Yet when the master takes her sick mother into his care, she must finally confront the man whose presence is as brooding as his windswept Yorkshire lands.  "), _c('br'), _c('br'), _vm._v("Men quake at Lord Rockford's mere command, yet this slip of a girl defies him at every turn! His fury at her is matched only by his desire, and Victoria's pure innocence burns brightly in the darkness of the hall. But the light threatens to lay bare secrets that could ruin them both.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0